import {Component, inject, OnInit} from '@angular/core';
import {BaseChartDirective} from "ng2-charts";
import {DecimalPipe, NgForOf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ChartConfiguration} from "chart.js";
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
import {AccessService} from "../../services/access.service";
import {ThemeService} from "../../services/theme.service";
import moment from "moment";

@Component({
    selector: 'app-product-evaluation',
    imports: [BaseChartDirective, FormsModule, NgForOf, DecimalPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-chart-simple me-2"></i>Detailauswertung</h3>
                </div>

                <div class="d-flex flex-wrap align-items-center gap-2">
                    <select class="form-control" style="width: 160px" [(ngModel)]="id_store" (ngModelChange)="loadData()">
                        <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                        <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
                    </select>

                    <div class="input-group" style="width: 170px">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" type="button" (click)="setYear(-1)">
                                <i class="fa-solid fa-arrow-left"></i>
                            </button>
                        </div>
                        <input type="number" class="form-control" name="year"
                               [(ngModel)]="year"
                               [max]="currentYear"
                               (ngModelChange)="loadData()"/>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" [disabled]="year == currentYear" (click)="setYear(1)">
                                <i class="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>

                    <div class="input-group" style="width: 200px">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" type="button" (click)="setMonth(-1)" [disabled]="month === ''">
                                <i class="fa-solid fa-arrow-left"></i>
                            </button>
                        </div>
                        <select class="form-control" name="month" [(ngModel)]="month" (ngModelChange)="loadData()">
                            <option value="" selected>Alle Monate</option>
                            <option *ngFor="let month of monthNames; let i = index" [value]="i">{{ month }}</option>
                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" (click)="setMonth(1)" [disabled]="month === ''">
                                <i class="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>

                    @if (month !== '') {
                        <div class="input-group" style="width: 165px">
                            <div class="input-group-prepend">
                                <button class="btn btn-outline-secondary" type="button" (click)="setDay(-1)" [disabled]="day === ''">
                                    <i class="fa-solid fa-arrow-left"></i>
                                </button>
                            </div>
                            <select class="form-control" [(ngModel)]="day" (ngModelChange)="loadData()">
                                <option value="" selected>Alle Tage</option>
                                <option *ngFor="let day of [].constructor(daysInMonth); let i = index" [value]="i + 1">{{ i + 1 }}</option>
                            </select>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" (click)="setDay(1)" [disabled]="day === ''">
                                    <i class="fa-solid fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    }

                    @if (storeProducts.length > 0) {
                        <select class="form-control" [(ngModel)]="selectedProduct" (ngModelChange)="onProductChange()" name="storeProduct" style="width: 250px">
                            <option value="" selected>Alle Produkte</option>
                            <option *ngFor="let product of storeProducts" [value]="product.item_product_name">{{ product.item_product_name }}</option>
                        </select>
                    }
                </div>

                @if (id_store === '') {
                    <div class="alert alert-warning mt-3 px-2 py-1" role="alert">
                        Bitte einen Store auswählen.
                    </div>
                } @else {
                    <ul class="nav nav-tabs my-3">
                        <li class="nav-item" (click)="setTab($event, 'top')">
                            <a class="nav-link" [class.active]="currentTab == 'top'" href>Top Produkte</a>
                        </li>
                        <li class="nav-item" (click)="setTab($event, 'daily')">
                            <a class="nav-link" [class.active]="currentTab == 'daily'" href>Tageschart</a>
                        </li>
                        <li class="nav-item" (click)="setTab($event, 'hourly')">
                            <a class="nav-link" [class.active]="currentTab == 'hourly'" href>Stundenchart</a>
                        </li>
                    </ul>
                }

                <h3 class="mt-3 mb-0 text-center">
                    @if (day) {
                        {{ day }}.
                    }
                    {{ monthNames[month] }} {{ year }}
                </h3>

                @if (topChart) {
                    <button type="button" class="btn btn-secondary" (click)="updateAllCharts('turnover')">Umsatz</button>
                    <button type="button" class="btn btn-secondary ms-2" (click)="updateAllCharts('sales')">Verkäufe</button>
                }

                @if (currentTab == 'top') {
                    @if (topChart) {
                        <div class="fs-6 fw-bold mt-3">
                            Gesamtumsatz: € {{ topChartTurnover | number: '1.2-2' }},
                            Gesamtverkäufe: {{ topChartSales | number: '1.0-0' }}
                        </div>

                        <div class="mt-3" [style.height]="topChartHeight">
                            <canvas baseChart
                                    [data]="topChart.data"
                                    [options]="topChart.options"
                                    [type]="topChart.type"
                                    class="mt-3">
                            </canvas>
                        </div>
                    }
                } @else if (currentTab == 'daily') {
                    @if (dailyChart) {
                        <div class="fs-6 fw-bold mt-3">
                            Gesamtumsatz: € {{ dailyChartTurnover | number: '1.2-2' }},
                            Gesamtverkäufe: {{ dailyChartSales | number: '1.0-0' }}
                        </div>

                        <div style="height: 700px;">
                            <canvas baseChart
                                    [data]="dailyChart.data"
                                    [options]="dailyChart.options"
                                    [type]="dailyChart.type"
                                    class="mt-3">
                            </canvas>
                        </div>
                    }
                } @else if (currentTab == 'hourly') {
                    @if (hourlyChart) {
                        <div class="fs-6 fw-bold mt-3">
                            Gesamtumsatz: € {{ hourlyChartTurnover | number: '1.2-2' }},
                            Gesamtverkäufe: {{ hourlyChartSales | number: '1.0-0' }}
                        </div>

                        <div style="height: 700px;">
                            <canvas baseChart
                                    [data]="hourlyChart.data"
                                    [options]="hourlyChart.options"
                                    [type]="hourlyChart.type"
                                    class="mt-3">
                            </canvas>
                        </div>
                    }
                }
            </div>
        </div>
    `
})
export class ProductEvaluationComponent implements OnInit {

    id_store = '';

    year: any;
    currentYear!: number;
    month: any;
    currentMonth!: number;
    day: any;
    currentDay!: number;
    daysInMonth: number;

    stores!: any[];
    storeProducts: any[] = [];
    selectedProduct: any = '';

    currentTab = 'top';

    monthNames = [
        'Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];

    chartType: string = 'turnover';

    private topChartData: any[] = [];
    topChart!: ChartConfiguration;
    topChartHeight: string = '400px';
    topChartTurnover = 0;
    topChartSales = 0;

    private dailyChartData: any[] = [];
    dailyChart!: ChartConfiguration;
    dailyChartHeight: string = '400px';
    dailyChartTurnover = 0;
    dailyChartSales = 0;

    private hourlyChartData: any[] = [];
    hourlyChart!: ChartConfiguration;
    hourlyChartTurnover = 0;
    hourlyChartSales = 0;

    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);
    private route = inject(ActivatedRoute);
    private accessService = inject(AccessService);
    private themeService = inject(ThemeService);

    ngOnInit(): void {
        this.currentYear = moment().year();
        this.currentMonth = moment().month();
        this.currentDay = moment().day();
        this.year = moment().year();
        this.month = moment().month();
        this.day = moment().date();

        this.calculateDaysInMonth();

        // Check for query parameters
        this.route.queryParams.subscribe(params => {
            if (params['id_store']) {
                this.id_store = params['id_store'];
            }
        });

        this.dataService.request("Store/listForSelection").subscribe(response => {
            this.stores = response.stores;
        })
    }

    onProductChange() {
        if (this.currentTab == 'top') this.setTab(null, 'detail');

        this.updateAllCharts(this.chartType);
    }

    calculateDaysInMonth() {
        if (this.month === '') return;

        this.daysInMonth = moment([this.year, this.month]).daysInMonth();
        if (this.day > this.daysInMonth) {
            this.day = this.daysInMonth;
        }
    }

    setYear(number: number) {
        this.year += number;

        this.loadData();
    }

    setMonth(number: number) {
        this.month = parseInt(this.month) + number;

        if (this.month < 0) {
            this.month = 11;
            this.setYear(-1);
        } else if (this.month > 11) {
            this.month = 0;
            this.setYear(1)
        } else {
            this.loadData();
        }
    }

    setDay(number: number) {
        this.day = parseInt(this.day) + number;

        if (this.day < 1) {
            this.day = 31;
            this.setMonth(-1);
        } else if (this.day > this.daysInMonth) {
            this.day = 1;
            this.setMonth(1);
        } else {
            this.loadData();
        }
    }

    loadData() {
        if (this.month === '') {
            this.day = '';
        }

        this.calculateDaysInMonth();

        this.dataService.request("Product/getChartData", {
            id_store: this.id_store,
            year: this.year,
            month: this.month !== "" ? parseInt(this.month) + 1 : '',
            day: this.day,
        }).subscribe(response => {

            this.storeProducts = response.storeProducts;

            this.topChartData = response.topChartData;

            // convert turnovers to float because MySQL won't do it
            this.topChartData.forEach(entry => {
                entry.turnover = parseFloat(entry.turnover);
            })

            this.dailyChartData = response.dailyChartData;

            this.hourlyChartData = response.hourlyChartData;

            this.updateAllCharts('turnover');
        })
    }

    updateAllCharts(type: string) {
        this.chartType = type;

        this.updateTopChart();
        this.updateDailyChart();
        this.updateHourlyChart();
    }

    updateTopChart() {
        if (this.chartType == 'sales') {
            this.topChartData.sort((a, b) => b.sales - a.sales);
        } else {
            this.topChartData.sort((a, b) => b.turnover - a.turnover);
        }

        this.topChartTurnover = this.topChartData.reduce((total, entry) => total + entry.turnover, 0);
        this.topChartSales = this.topChartData.reduce((total, entry) => total + entry.sales, 0);

        const productNames: string[] = this.topChartData.map(entry => {
            let name = entry.item_product_name;
            if (entry.product_itemnumber) {
                name += ' (' + entry.product_itemnumber + ')';
            }
            return name;
        });
        const data: any[] = this.topChartData.map(entry => this.chartType == 'sales' ? entry.sales : entry.turnover);

        // Calculate height based on number of labels (50px per label, minimum 400px)
        this.topChartHeight = Math.max(400, productNames.length * 30) + 'px';

        this.topChart = {
            data: {
                labels: productNames,
                datasets: [
                    {
                        label: this.chartType == 'sales' ? 'Verkäufe' : 'Umsatz',
                        data: data,
                        backgroundColor: this.accessService.client.primaryColor,
                        borderColor: this.accessService.client.primaryColor,
                        borderRadius: 8,
                        borderSkipped: 'start',
                        barPercentage: 0.5,
                    }
                ],
            },
            options: {
                indexAxis: 'y',
                maintainAspectRatio: false,
                scales: {
                    x: {
                        min: -5,
                        ticks: {
                            callback: (value: any) => {
                                if (this.chartType === 'turnover') {
                                    return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                                }
                                return value;
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    datalabels: {
                        anchor: 'end',
                        align: (context) => {
                            const value = context.dataset.data[context.dataIndex] as number;
                            const max = Math.max(...(context.dataset.data as number[]));
                            return value < max * 0.1 ? 'end' : 'start';
                        },
                        color: this.themeService.isDarkMode ? '#fff' : '#000',
                        font: {
                            weight: 'bold'
                        },
                        formatter: (value: any) => {
                            if (this.chartType === 'turnover') {
                                return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                            }
                            return value;
                        }
                    }
                },
                elements: {
                    bar: {
                        borderRadius: 8,
                        borderSkipped: false,
                    }
                },
            },
            type: 'bar',
        };
    }

    updateDailyChart() {
        let chartData = this.dailyChartData;

        // Filter by selected product if one is set
        if (this.selectedProduct != "") {
            chartData = chartData.filter(entry => entry.item_product_name === this.selectedProduct);
        }

        if (this.chartType == 'sales') {
            chartData.sort((a, b) => b.sales - a.sales);
        } else {
            chartData.sort((a, b) => b.turnover - a.turnover);
        }

        this.dailyChartTurnover = chartData.reduce((total, entry) => total + parseFloat(entry.turnover), 0);
        this.dailyChartSales = chartData.reduce((total, entry) => total + entry.sales, 0);

        // Extract unique dates
        const dates: any[] = [...new Set(chartData.map(entry => entry.date))];

        // Format dates as "dd, D.M.Y"
        const formattedDates = dates.map(date => moment(date).format('dd, DD.MM.Y'));

        const data: any[] = chartData.map(entry => this.chartType == 'sales' ? entry.sales : entry.turnover);

        // Calculate height based on number of labels (50px per label, minimum 400px)
        this.dailyChartHeight = Math.max(400, dates.length * 30) + 'px';

        this.dailyChart = {
            data: {
                labels: formattedDates,
                datasets: [
                    {
                        label: this.chartType == 'sales' ? 'Verkäufe' : 'Umsatz',
                        data: data,
                        backgroundColor: this.accessService.client.primaryColor,
                        borderColor: this.accessService.client.primaryColor,
                        borderRadius: 8,
                        borderSkipped: 'start',
                        barPercentage: 0.5,
                    }
                ],
            },
            options: {
                indexAxis: 'y',
                maintainAspectRatio: false,
                scales: {
                    x: {
                        ticks: {
                            callback: (value: any) => {
                                if (this.chartType === 'turnover') {
                                    return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                                }
                                return value;
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                    },
                    tooltip: {
                        enabled: false,
                    },
                    datalabels: {
                        anchor: 'end',
                        align: (context) => {
                            const value = context.dataset.data[context.dataIndex] as number;
                            const max = Math.max(...(context.dataset.data as number[]));
                            return value < max * 0.1 ? 'end' : 'start';
                        },
                        color: this.themeService.isDarkMode ? '#fff' : '#000',
                        font: {
                            weight: 'bold'
                        },
                        formatter: (value: any) => {
                            if (this.chartType === 'turnover') {
                                return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                            }
                            return value;
                        }
                    }
                },
            },
            type: 'bar',
        };
    }

    updateHourlyChart() {
        let chartData = this.hourlyChartData;

        // Filter by selected product if one is set
        if (this.selectedProduct != "") {
            chartData = chartData.filter(entry => entry.item_product_name === this.selectedProduct);
        }

        /*if (this.chartType == 'sales') {
            chartData.sort((a, b) => b.sales - a.sales);
        } else {
            chartData.sort((a, b) => b.turnover - a.turnover);
        }*/

        this.hourlyChartTurnover = chartData.reduce((total, entry) => total + parseFloat(entry.turnover), 0);
        this.hourlyChartSales = chartData.reduce((total, entry) => total + entry.sales, 0);


        // Extract unique hours and sort them
        const hours: number[] = [...new Set(chartData.map(entry => entry.hour))];

        // Format hours as labels (e.g., "00:00", "01:00", etc.)
        const hourLabels = hours.map(hour => `${hour.toString().padStart(2, '0')}:00`);

        const data: any[] = chartData.map(entry => this.chartType == 'sales' ? entry.sales : entry.turnover);

        this.hourlyChart = {
            data: {
                labels: hourLabels,
                datasets: [
                    {
                        label: this.chartType == 'sales' ? 'Verkäufe' : 'Umsatz',
                        data: data,
                        backgroundColor: this.accessService.client.primaryColor,
                        borderColor: this.accessService.client.primaryColor,
                        borderRadius: 8,
                        borderSkipped: 'start',
                        barPercentage: 0.5,
                    }
                ],
            },
            options: {
                indexAxis: 'y',
                maintainAspectRatio: false,
                scales: {
                    x: {
                        ticks: {
                            callback: (value: any) => {
                                if (this.chartType === 'turnover') {
                                    return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                                }
                                return value;
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                    },
                    tooltip: {
                        enabled: false,
                    },
                    datalabels: {
                        anchor: 'end',
                        align: (context) => {
                            const value = context.dataset.data[context.dataIndex] as number;
                            const max = Math.max(...(context.dataset.data as number[]));
                            return value < max * 0.1 ? 'end' : 'start';
                        },
                        color: this.themeService.isDarkMode ? '#fff' : '#000',
                        font: {
                            weight: 'bold'
                        },
                        formatter: (value: any) => {
                            if (this.chartType === 'turnover') {
                                return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
                            }
                            return value;
                        }
                    }
                },
            },
            type: 'bar',
        };
    }

    generateColors(count: number): string[] {
        const baseColor = this.accessService.client.primaryColor || '#3b82f6';
        const colors: string[] = [];

        for (let i = 0; i < count; i++) {
            const hue = (i * 360 / count) % 360;
            colors.push(`hsl(${hue}, 70%, 60%)`);
        }

        return colors;
    }

    protected setTab(event, tab: string) {
        event?.preventDefault();
        this.currentTab = tab;
    }

}
